import APPCONFIG from 'constants/Config';
import {
  TOGGLE_LOADING,
  TOGGLE_API_ERROR,
  TOGGLE_ALERT_ERROR,
  SWITCH_LANGUAGE,
  UPDATE_API_STATUS,
  UPDATE_SETTINGS,
} from 'stores/types';

const initialSettings = Object.assign( {
  isApiError: false,
  apiErrorMessage: '',
  isLoading: false,
  errorMessage: '',
  locale: {
    languageId: 'english',
    locale: 'en',
    name: 'English',
    icon: 'gb',
  },
  apiStatus: {},
  networkSettings: {
    facebookLimit: -1,
    twitterLimit: -1,
    emailLimit: -1,
  }
}, APPCONFIG.settings );

const settings = ( state = initialSettings, action ) => {
  switch( action.type ) {

    case TOGGLE_API_ERROR:
      return {
        ...state,
        apiErrorMessage: action.apiErrorMessage,
      };
    case TOGGLE_LOADING:
      return {
        ...state,
        isLoading: action.isLoading
      };
    case TOGGLE_ALERT_ERROR:
      return {
        ...state,
        errorMessage: action.message,
        msgToCopy: action.msgToCopy
      };
    case SWITCH_LANGUAGE:
      return {
        ...state,
        locale: action.locale
      };
    case UPDATE_API_STATUS:
      return {
        ...state,
        apiStatus: action.data
      };
    case UPDATE_SETTINGS:
      return {
        ...state,
        ...action.data
      };
    default:
      return state;
  }
};

export { initialSettings };
export default settings;



// WEBPACK FOOTER //
// ./stores/reducers/common/settings.js